export enum Font {
  YESMyoungjo = 'YESMyoungjo',
  NanumSquareNeo = 'NanumSquareNeoOTF-bRg',
  RidiBatang = 'RIDIBatang',
  Pretendard = 'Pretendard',
  WavvePADO = 'WavvePADO',
  BRB = 'BRB',
  OwnGlyphPDH = 'OwnGlyphPDH',
  ChosunCentennial = 'ChosunCentennial',
  KBODiaGothic = 'KBODiaGothic',
  BookkMyungjo = 'BookkMyungjo',
  Warhaven = 'Warhaven',
}

export const FancyShareFontList = [Font.RidiBatang, Font.NanumSquareNeo, Font.YESMyoungjo];

export const ContentCoverFontList = [
  Font.WavvePADO,
  Font.BRB,
  Font.OwnGlyphPDH,
  Font.ChosunCentennial,
  Font.KBODiaGothic,
  Font.BookkMyungjo,
  Font.Warhaven,
  Font.YESMyoungjo,
  Font.RidiBatang,
  Font.NanumSquareNeo,
  Font.Pretendard,
];

export const FontText: Record<Font, string> = {
  [Font.WavvePADO]: '웨이브 파도',
  [Font.BRB]: '베스킨라빈스B',
  [Font.OwnGlyphPDH]: '온글잎 박다현',
  [Font.ChosunCentennial]: '조선100년',
  [Font.KBODiaGothic]: 'KBO 다이아고딕',
  [Font.BookkMyungjo]: '부크크 명조',
  [Font.Warhaven]: '넥슨 워헤이븐',
  [Font.YESMyoungjo]: '예스 명조',
  [Font.RidiBatang]: '리디바탕',
  [Font.NanumSquareNeo]: '나눔스퀘어네오',
  [Font.Pretendard]: 'Pretendard',
};
